import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import { SystemEntity } from '@erp/shared-types';

export function useActivityLog(
  entityType: SystemEntity,
  entityId: string,
  options?: { limit?: number; offset?: number; enabled?: boolean },
) {
  return useQuery(
    orpc.core.activityLog.list.queryOptions({
      input: {
        entityType,
        entityId,
        limit: options?.limit,
        offset: options?.offset,
      },
      enabled: options?.enabled ?? true,
    }),
  );
}
